import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Перлова Наталія',
  role: 'Голова комісії з етики',
  email: 'kazbekovs12@gmail.com'
}, {
  name: 'Маренич Валентина',
  role: 'Членкиня комісії з етики',
  email: 'vertykal.kh@gmail.com'
}, {
  name: 'Яненко Олександрина',
  role: 'Членкиня комісії з етики',
  email: 'yanenkooleksandryna@gmail.com'
}];
export function EthicsCommission() {
  return <FederationMembersPage title="Комісія з етики" subtitle="Комісія з етики скельного комітету ФАіСУ" members={members} data-id="element-562" />;
}